"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./Offline.scss");
var PaymentMethodLayout_1 = require("./../PaymentMethodLayout");
var Translate_1 = require("./../Translate");
var Offline = (function (_super) {
    __extends(Offline, _super);
    function Offline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getText = function (info) {
            return (info && info.text) || Translate_1.translate({ forKey: 'payments.offline.defaultInstructionText' });
        };
        return _this;
    }
    Offline.prototype.render = function () {
        var info = this.props.info;
        var text = this.getText(info).trim();
        if (!text) {
            return null;
        }
        return (React.createElement(PaymentMethodLayout_1.default, { dataHook: "cashier-payments-method-offline" },
            React.createElement("span", { className: s.content, dangerouslySetInnerHTML: { __html: text } })));
    };
    return Offline;
}(React.Component));
exports.default = Offline;
//# sourceMappingURL=Offline.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Offline/Offline.js
// module id = 210
// module chunks = 0 1